export default __webpack_public_path__ + "static/media/services.dd07062e.svg";